/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of entity that can be commented on
 * @export
 */
export const CommentEntityType = {
    Track: 'Track',
    FanClub: 'FanClub',
    Event: 'Event'
} as const;
export type CommentEntityType = typeof CommentEntityType[keyof typeof CommentEntityType];


export function CommentEntityTypeFromJSON(json: any): CommentEntityType {
    return CommentEntityTypeFromJSONTyped(json, false);
}

export function CommentEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentEntityType {
    return json as CommentEntityType;
}

export function CommentEntityTypeToJSON(value?: CommentEntityType | null): any {
    return value as any;
}

